import {gql} from '@apollo/client'

const RESOURCE_CATEGORY_FIELDS = gql`
  fragment ResourceCategoryFields on resource_category_type {
    id
    name
    parent {
      id
    }
    order
    isActive
    childrenCount
    resourcesCount
    created
    updated
  }
`

// Árbol completo de categorías de la organización (lista plana, el cliente arma el árbol)
export const GET_RESOURCE_CATEGORY_TREE = gql`
  ${RESOURCE_CATEGORY_FIELDS}
  query getResourceCategoryTree($includeInactive: Boolean) {
    resourceCategoryTree(includeInactive: $includeInactive) {
      ...ResourceCategoryFields
    }
  }
`

export const GET_RESOURCE_CATEGORY_BY_ID = gql`
  ${RESOURCE_CATEGORY_FIELDS}
  query getResourceCategoryById($id: Int!) {
    resourceCategoryById(id: $id) {
      ...ResourceCategoryFields
    }
  }
`
